import { render, staticRenderFns } from "./AppTableOtrosIngresos.vue?vue&type=template&id=467e2d68&scoped=true"
import script from "./AppTableOtrosIngresos.vue?vue&type=script&lang=js"
export * from "./AppTableOtrosIngresos.vue?vue&type=script&lang=js"
import style0 from "./AppTableOtrosIngresos.vue?vue&type=style&index=0&id=467e2d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e2d68",
  null
  
)

export default component.exports